import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';

const FilterTermsSelectItem = (props) => {
  const { data } = props;
  return (
    <components.Option {...props}>
      <div className="filter-terms-select-item">
        {data.label}
      </div>
    </components.Option>
  );
};

FilterTermsSelectItem.propTypes = {
  data: PropTypes.object.isRequired,
};

export default FilterTermsSelectItem;
